import { Component } from '@angular/core';
import { BannerMessage, BannerService, BannerType } from '../../services/banner.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-global-banner',
  templateUrl: './global-banner.component.html',
  styleUrls: ['./global-banner.component.scss']
})
export class GlobalBannerComponent {
  warningMessages: string[] = []
  errorMessages: string[] = []
  infoMessages: string[] = []
  destroy$: Subscription = new Subscription()
  constructor(private bannerService: BannerService) {
    
    //this.errorMessages = ['Error message one', 'Error message two']
    //this.warningMessages = ['Warning message one', 'Warning message two']
    //this.infoMessages = ['Test test']
  }
  ngOnInit(){
    this.destroy$ = this.bannerService.messageSubject.subscribe((values: BannerMessage[]) => {
      console.log('in global banner component')
      let updateWarningMessages: string[] = []
      let updateErrorMessages: string[] = []
      let updateInfoMessages: string[] = []
      for (const val of values) {
        switch (val.type) {
          case (BannerType.warning): {
            updateWarningMessages.push(val.content)
            break
          }
          case (BannerType.error): {
            updateErrorMessages.push(val.content)
            break
          }
          default: {
            updateInfoMessages.push(val.content)
            break
          }
        }
      }
      this.warningMessages = updateWarningMessages
      this.errorMessages = updateErrorMessages
      this.infoMessages = updateInfoMessages
    })
  }
  ngOnDestroy() {
    this.destroy$.unsubscribe();
  }
}
